import { Component, OnInit, Inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { FormService } from "../../services/forms/form.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { FieldFormService } from "../../services/forms/field-form.service";

import { LayerService } from "../../../home/services/layers/layer.service";

@Component({
  selector: "app-modal-forms",
  templateUrl: "./modal-forms.component.html",
  styleUrls: ["./modal-forms.component.css"]
})
export class ModalFormsComponent implements OnInit {
  selectedValue: string;
  fields: any;
  layers: any;

  constructor(
    protected formService: FormService,
    protected fieldFormService: FieldFormService,
    protected layerService: LayerService,
    private dialogRef: MatDialogRef<ModalFormsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.layerService.getLayers().subscribe((data: {}) => {
      this.layers = data;
    });
  }

  name: any;
  description: any;
  layer: any;

  ngOnInit() {}

  public closeMe() {
    this.dialogRef.close();
  }

  public createForm() {
    const formDetails = {
      formulario_nombre: this.name,
      formulario_descripcion: this.description,
      capa_id: this.layer,
      formulario_estado: 1
    };

    this.formService.createForm(formDetails).subscribe((data: {}) => {
      this.dialogRef.close({ data });
      let fieldFormDetails;
    });
  }
}
